<script>
  import lodash from 'lodash'
  import axios from 'axios'
  import bus from '@/utils/eventBus'

  export default {
    name: 'location-real-time',
    data: () => ({
      place: '',
      latitude: '',
      longitude: '',
      active: true,
      address: null
    }),
    watch: {
      place () {
        this.latitude = ''
        this.longitude = ''
        this.active = true
        this.address = ''
        if (this.place.length >= 3) {
          this.active = false
          this.lookupCoordinates()
        }
      }
    },
    methods: {
      lookupCoordinates: lodash.debounce(function () {
        this.latitude = 'Localizando aguarde...'
        this.longitude = 'Localizando aguarde...'
        axios.get('https://maps.googleapis.com/maps/api/geocode/json?address=' + this.place + '"&key=AIzaSyDoJ5GovMYNr303IQlckxcE4eKFtBa9y9Q')
          .then((response) => {
            bus.$emit('real-location', {latitude: response.data.results[0].geometry.location.lat, longitude: response.data.results[0].geometry.location.lng})
            this.latitude = response.data.results[0].geometry.location.lat
            this.longitude = response.data.results[0].geometry.location.lng
            this.address = response.data.results[0].formatted_address
          })
          .catch(() => {
            this.latitude = 'Invalid place'
            this.longitude = 'Invalid place'
          })
      }, 500)
    }
  }
</script>

<template lang="pug">
    .row
      .col-md-12
        input.form-control(type='text', placeholder='Digite aqui o Endereço, CEP ou cidade', autofocus='true', v-model='place')
      .col-md-12(v-bind:class="{ 'not-visible' : active }")
        p.m-t-20
          strong {{ address}}
        hr
      //-.col-md-12(v-bind:class="{ 'not-visible' : active }")
        iframe(v-if='place.length >= 3', frameborder='0', style='width: 100%; height: 200px; border:0', v-bind:src="'https://www.google.com/maps/embed/v1/place?key=AIzaSyDoJ5GovMYNr303IQlckxcE4eKFtBa9y9Q&q=' + place", allowfullscreen='')

</template>
<style scopde>
  .m-t-20 {
    margin: 16px 4px 5px;
  }
</style>



// WEBPACK FOOTER //
// src/app/patient/agendas/search/advanced/components/location-real-time.vue